import React from 'react';

import Div from '../../../../div';

export default ({ value, onChange, id }) =>
    <label style={{ width:'100%' }}>
        <Div setup='r between center' wRel='100'>
            <Div>VIP hráč:</Div>
            <Div fx='50' style={{textAlign: 'right' }}>
                <input type='checkbox' style={{height: '35px', width: '35px', marginRight: '10px'}}
                       checked={value ? 'checked' : ''} onChange={() => onChange(!value)}
                       id={id} />
            </Div>
        </Div>
    </label>